const makeSrcSet = (src: string) => {
  return `${require(`${src}.png`)} 600w,
  ${require(`${src}@2x.png`)} 1024w,
  ${require(`${src}@3x.png`)} 1440w`;
};

const makeSrcSetMAX2x = (src: string) => {
  return `${require(`${src}.png`)} 600w,
  ${require(`${src}@2x.png`)} 1024w,
  ${require(`${src}@2x.png`)} 1440w`;
};

const makeSrcSetSVG = (src: string) => {
  return `${require(`${src}.svg`)} 600w,
  ${require(`${src}.svg`)} 1024w,
  ${require(`${src}.svg`)} 1440w`;
};

const makeSrcSVG = (src: string) => {
  return require(`${src}.svg`);
};

const makeSrcPNG = (src: string) => {
  return require(`${src}@2x.png`);
};

const images = {
  kbBankLogoSrc: makeSrcSVG("./kb_bank_logo"),
  kbBankLogo: makeSrcSetSVG("./kb_bank_logo"),
  kbBankEnLogoSrc: makeSrcSVG("./kb_bank_en_logo"),
  kbBankEnLogo: makeSrcSetSVG("./kb_bank_en_logo"),
  hashedLogoSrc: makeSrcSVG("./hashed_logo"),
  hashedLogo: makeSrcSetSVG("./hashed_logo"),
  bitberryLogoSrc: makeSrcSVG("./bitberry_logo"),
  bitberryLogo: makeSrcSetSVG("./bitberry_logo"),
  flybitLogoSrc: makeSrcSVG("./flybit_logo"),
  flybitLogo: makeSrcSetSVG("./flybit_logo"),
  mediumLogoSrc: makeSrcSVG("./medium_logo"),
  mediumLogo: makeSrcSetSVG("./medium_logo"),
  emailLogoSrc: makeSrcSVG("./email_logo"),
  emailLogo: makeSrcSetSVG("./email_logo"),
  henesisLogoSrc: makeSrcSVG("./henesis_logo"),
  henesisLogo: makeSrcSetSVG("./henesis_logo"),
  haechiLogoSrc: makeSrcSVG("./haechi_logo"),
  haechiLogo: makeSrcSetSVG("./haechi_logo"),
  shinhanBankLogoSrc: makeSrcSVG("./shinhan_bank_logo"),
  shinhanBankLogo: makeSrcSetSVG("./shinhan_bank_logo"),
  shinhanBankEnLogoSrc: makeSrcSVG("./shinhan_bank_en_logo"),
  shinhanBankEnLogo: makeSrcSetSVG("./shinhan_bank_en_logo"),
  kodaLogoSrc: makeSrcSVG("./koda_logo"),
  kodaLogo: makeSrcSetSVG("./koda_logo"),
  bithumbLogoSrc: makeSrcSVG("./bithumb_logo"),
  bithumbLogo: makeSrcSetSVG("./bithumb_logo"),
  fintechLogoSrc: makeSrcSVG("./fintech_logo"),
  fintechLogo: makeSrcSetSVG("./fintech_logo"),
  gdacLogoSrc: makeSrcSVG("./gdac_logo"),
  gdacLogo: makeSrcSetSVG("./gdac_logo"),
  indodaxLogoSrc: makeSrcSVG("./indodax_logo"),
  indodaxLogo: makeSrcSetSVG("./indodax_logo"),
  customer11ssLogoSrc: makeSrcSVG("./customer_11ss_logo"),
  customer11ssLogo: makeSrcSetSVG("./customer_11ss_logo"),
  customerBitberryLogoSrc: makeSrcSVG("./customer_bitberry_logo"),
  customerBitberryLogo: makeSrcSetSVG("./customer_bitberry_logo"),
  customerCarryLogoSrc: makeSrcSVG("./customer_carry_logo"),
  customerCarryLogo: makeSrcSetSVG("./customer_carry_logo"),
  customerDanalLogoSrc: makeSrcSVG("./customer_danal_logo"),
  customerDanalLogo: makeSrcSetSVG("./customer_danal_logo"),
  customerFlybitLogoSrc: makeSrcSVG("./customer_flybit_logo"),
  customerFlybitLogo: makeSrcSetSVG("./customer_flybit_logo"),
  customerFoblgateLogoSrc: makeSrcSVG("./customer_foblgate_logo"),
  customerFoblgateLogo: makeSrcSetSVG("./customer_foblgate_logo"),
  customerHashedLogoSrc: makeSrcSVG("./customer_hashed_logo"),
  customerHashedLogo: makeSrcSetSVG("./customer_hashed_logo"),
  customerKBBankEnLogoSrc: makeSrcSVG("./customer_kb_bank_en_logo"),
  customerKBBankEnLogo: makeSrcSetSVG("./customer_kb_bank_en_logo"),
  customerKBBankLogoSrc: makeSrcSVG("./customer_kb_bank_logo"),
  customerKBBankLogo: makeSrcSetSVG("./customer_kb_bank_logo"),
  customerKodaLogoSrc: makeSrcSVG("./customer_koda_logo"),
  customerKodaLogo: makeSrcSetSVG("./customer_koda_logo"),
  customerSandbankLogoSrc: makeSrcSVG("./customer_sandbank_logo"),
  customerSandbankLogo: makeSrcSetSVG("./customer_sandbank_logo"),
  customerShinhanBankEnLogoSrc: makeSrcSVG("./customer_shinhan_bank_en_logo"),
  customerShinhanBankEnLogo: makeSrcSetSVG("./customer_shinhan_bank_en_logo"),
  customerShinhanBankLogoSrc: makeSrcSVG("./customer_shinhan_bank_logo"),
  customerShinhanBankLogo: makeSrcSetSVG("./customer_shinhan_bank_logo"),
  customerZiktoLogoSrc: makeSrcSVG("./customer_zikto_logo"),
  customerZiktoLogo: makeSrcSetSVG("./customer_zikto_logo"),
  customer1inchLogoSrc: makeSrcSVG("./customer_1inch_logo"),
  customer1inchLogo: makeSrcSetSVG("./customer_1inch_logo"),
  customerBadgerLogoSrc: makeSrcSVG("./customer_badger_logo"),
  customerBadgerLogo: makeSrcSetSVG("./customer_badger_logo"),
  customerBithumbLogoSrc: makeSrcSVG("./customer_bithumb_logo"),
  customerBithumbLogo: makeSrcSetSVG("./customer_bithumb_logo"),
  customerKlaytnLogoSrc: makeSrcSVG("./customer_klaytn_logo"),
  customerKlaytnLogo: makeSrcSetSVG("./customer_klaytn_logo"),
  customerLGLogoSrc: makeSrcSVG("./customer_lg_logo"),
  customerLGLogo: makeSrcSetSVG("./customer_lg_logo"),
  customerSKSecuritiesEnLogoSrc: makeSrcSVG("./customer_sk_securities_en_logo"),
  customerSKSecuritiesEnLogo: makeSrcSetSVG("./customer_sk_securities_en_logo"),
  customerSKSecuritiesLogoSrc: makeSrcSVG("./customer_sk_securities_logo"),
  customerSKSecuritiesLogo: makeSrcSetSVG("./customer_sk_securities_logo"),
  customerSushiSwapLogoSrc: makeSrcSVG("./customer_sushi_swap_logo"),
  customerSushiSwapLogo: makeSrcSetSVG("./customer_sushi_swap_logo"),
  customerSKTelecomLogoSrc: makeSrcSVG("./customer_sk_telecom_logo"),
  customerSKTelecomLogo: makeSrcSetSVG("./customer_sk_telecom_logo"),
  blockchainBSCLogoSrc: makeSrcSVG("./blockchain_bsc_logo"),
  blockchainBSCLogo: makeSrcSetSVG("./blockchain_bsc_logo"),
  blockchainBTCCashLogoSrc: makeSrcSVG("./blockchain_btc_cash_logo"),
  blockchainBTCCashLogo: makeSrcSetSVG("./blockchain_btc_cash_logo"),
  blockchainBTCLogoSrc: makeSrcSVG("./blockchain_btc_logo"),
  blockchainBTCLogo: makeSrcSetSVG("./blockchain_btc_logo"),
  blockchainETHLogoSrc: makeSrcSVG("./blockchain_eth_logo"),
  blockchainETHLogo: makeSrcSetSVG("./blockchain_eth_logo"),
  blockchainFilecoinLogoSrc: makeSrcSVG("./blockchain_filecoin_logo"),
  blockchainFilecoinLogo: makeSrcSetSVG("./blockchain_filecoin_logo"),
  blockchainKlaytnLogoSrc: makeSrcSVG("./blockchain_klaytn_logo"),
  blockchainKlaytnLogo: makeSrcSetSVG("./blockchain_klaytn_logo"),
  blockchainLitecoinLogoSrc: makeSrcSVG("./blockchain_litecoin_logo"),
  blockchainLitecoinLogo: makeSrcSetSVG("./blockchain_litecoin_logo"),
  blockchainOthersLogoSrc: makeSrcSVG("./blockchain_others_logo"),
  blockchainOthersLogo: makeSrcSetSVG("./blockchain_others_logo"),
  externalicLinkSrc: makeSrcSVG("./externalic_link"),
  externalicLink: makeSrcSVG("./externalic_link"),
  keyboardArrowDownSrc: makeSrcSVG("./keyboard_arrow_down"),
  keyboardArrowDown: makeSrcSVG("./keyboard_arrow_down"),
  serviceBgSrc: makeSrcPNG("./service_bg"),
  serviceBg: makeSrcSet("./service_bg"),
  serviceEnBgSrc: makeSrcPNG("./service_en_bg"),
  serviceEnBg: makeSrcSet("./service_en_bg"),
  serviceBg2Src: makeSrcPNG("./service_bg2"),
  serviceBg2: makeSrcSet("./service_bg2"),
  usecasePhoneSrc: makeSrcPNG("./usecase_phone"),
  usecasePhone: makeSrcSet("./usecase_phone"),
  usecasePhone2Src: makeSrcPNG("./usecase_phone2"),
  usecasePhone2: makeSrcSet("./usecase_phone2"),
  usecaseConsignmentProfileSrc: makeSrcPNG("./usecase_consignment_profile"),
  usecaseConsignmentProfile: makeSrcPNG("./usecase_consignment_profile"),
  usecasePaymentProfileSrc: makeSrcPNG("./usecase_payment_profile"),
  usecasePaymentProfile: makeSrcPNG("./usecase_payment_profile"),
  usecaseExchange2ProfileSrc: makeSrcPNG("./usecase_exchange2_profile"),
  usecaseExchange2Profile: makeSrcPNG("./usecase_exchange2_profile"),
  usecaseExchange2RightBgSrc: makeSrcPNG("./usecase_exchange2_right_bg"),
  usecaseExchange2RightBg: makeSrcPNG("./usecase_exchange2_right_bg"),
  usecaseExchange2RightEnBgSrc: makeSrcPNG("./usecase_exchange2_right_en_bg"),
  usecaseExchange2RightEnBg: makeSrcPNG("./usecase_exchange2_right_en_bg"),
  usecaseWalletProfileSrc: makeSrcPNG("./usecase_wallet_profile"),
  usecaseWalletProfile: makeSrcPNG("./usecase_wallet_profile"),
  usecaseWalletRightBgSrc: makeSrcPNG("./usecase_wallet_right_bg"),
  usecaseWalletRightBg: makeSrcPNG("./usecase_wallet_right_bg"),
  usecaseWalletRightEnBgSrc: makeSrcPNG("./usecase_wallet_right_en_bg"),
  usecaseWalletRightEnBg: makeSrcPNG("./usecase_wallet_right_en_bg"),
  usecaseConsignmentRightBgSrc: makeSrcPNG("./usecase_consignment_right_bg"),
  usecaseConsignmentRightBg: makeSrcPNG("./usecase_consignment_right_bg"),
  usecasePaymentRightBgSrc: makeSrcPNG("./usecase_payment_right_bg"),
  usecasePaymentRightBg: makeSrcPNG("./usecase_payment_right_bg"),
  carouselArrowLeftSrc: makeSrcSVG("./carousel_arrow_left"),
  carouselArrowLeft: makeSrcSetSVG("./carousel_arrow_left"),
  carouselArrowRightSrc: makeSrcSVG("./carousel_arrow_right"),
  carouselArrowRight: makeSrcSetSVG("./carousel_arrow_right"),
  arrowRightSrc: makeSrcSVG("./arrow_right"),
  arrowRight: makeSrcSetSVG("./arrow_right"),
  arrowRightWhiteSrc: makeSrcSVG("./arrow_right_white"),
  arrowRightWhite: makeSrcSetSVG("./arrow_right_white"),
  multisigWalletLogoSrc: makeSrcSVG("./multisig_wallet_logo"),
  multisigWalletLogo: makeSrcSetSVG("./multisig_wallet_logo"),
  hackingGuardLogoSrc: makeSrcSVG("./hacking_guard_logo"),
  hackingGuardLogo: makeSrcSetSVG("./hacking_guard_logo"),
  authSeperationLogoSrc: makeSrcSVG("./auth_seperation_logo"),
  authSeperationLogo: makeSrcSetSVG("./auth_seperation_logo"),
  supportWalletLogoSrc: makeSrcSVG("./support_wallet_logo"),
  supportWalletLogo: makeSrcSetSVG("./support_wallet_logo"),
  saveGasFeesLogoSrc: makeSrcSVG("./save_gas_fees_logo"),
  saveGasFeesLogo: makeSrcSetSVG("./save_gas_fees_logo"),
  apiBgSrc: makeSrcPNG("./api_bg"),
  apiBg: makeSrcSet("./api_bg"),
  gasFeesBgSrc: makeSrcPNG("./gas_fees_bg"),
  gasFeesEnBgSrc: makeSrcPNG("./gas_fees_en_bg"),
  dashboardBgSrc: makeSrcPNG("./dashboard_bg"),
  dashboardBg: makeSrcSet("./dashboard_bg"),
  dashboardEnBgSrc: makeSrcPNG("./dashboard_en_bg"),
  dashboardEnBg: makeSrcSet("./dashboard_en_bg"),
  dashboardIntro1Src: makeSrcPNG("./dashboard_intro1"),
  dashboardIntro1EnSrc: makeSrcPNG("./dashboard_intro1_en"),
  dashboardIntro2Src: makeSrcPNG("./dashboard_intro2"),
  dashboardIntro2EnSrc: makeSrcPNG("./dashboard_intro2_en"),
  dashboardIntro3Src: makeSrcPNG("./dashboard_intro3"),
  dashboardIntro3EnSrc: makeSrcPNG("./dashboard_intro3_en"),
  dashboardIntro4Src: makeSrcPNG("./dashboard_intro4"),
  dashboardIntro4EnSrc: makeSrcPNG("./dashboard_intro4_en"),
  dashboardIntro5Src: makeSrcPNG("./dashboard_intro5"),
  dashboardIntro5EnSrc: makeSrcPNG("./dashboard_intro5_en"),
  dashboardIntroApiSrc: makeSrcPNG("./dashboard_intro_api"),
  dashboardIntroApi: makeSrcSet("./dashboard_intro_api"),
  transactionFeeManagement1Src: makeSrcPNG("./transaction_fee_management1"),
  transactionFeeManagement1: makeSrcSet("./transaction_fee_management1"),
  transactionFeeManagement2Src: makeSrcPNG("./transaction_fee_management2"),
  transactionFeeManagement2: makeSrcSet("./transaction_fee_management2"),
  security1Src: makeSrcPNG("./security1"),
  security1: makeSrcSet("./security1"),
  security2Src: makeSrcPNG("./security2"),
  security2: makeSrcSet("./security2"),
  security3Src: makeSrcPNG("./security3"),
  security3: makeSrcSet("./security3"),
  security4Src: makeSrcPNG("./security4"),
  security4: makeSrcSet("./security4"),
  security5Src: makeSrcPNG("./security5"),
  security5: makeSrcSet("./security5"),
  localeSrc: makeSrcSVG("./locale"),
  locale: makeSrcSetSVG("./locale"),
  hamburgerMenuSrc: makeSrcSVG("./hamburger_menu"),
  hamburgerMenu: makeSrcSetSVG("./hamburger_menu"),
  hamburgerCloseSrc: makeSrcSVG("./hamburger_close"),
  hamburgerClose: makeSrcSetSVG("./hamburger_close"),
  ziktoProfileSrc: makeSrcPNG("./zikto_profile"),
  ziktoProfile: makeSrcSet("./zikto_profile"),
  flybitProfileSrc: makeSrcPNG("./flybit_profile"),
  flybitProfile: makeSrcSet("./flybit_profile"),
  henesisWhiteLogoSrc: makeSrcSVG("./henesis_white_logo"),
  henesisWhiteLogo: makeSrcSetSVG("./henesis_white_logo"),
  haechiWhiteLogoSrc: makeSrcSVG("./haechi_white_logo"),
  haechiWhiteLogo: makeSrcSetSVG("./haechi_white_logo"),
  eventDanalWebinarBg: makeSrcPNG("./event_danal_webinar_bg"),
  eventDanalWebinarMobileBg: makeSrcPNG("./event_danal_webinar_mobile_bg"),
  henesisEthereumBg: makeSrcPNG("./henesis_ethereum_bg"),
  henesisEthereumMobileBg: makeSrcPNG("./henesis_ethereum_mobile_bg"),
  arrowRightGreySrc: makeSrcPNG("./arrow_right_grey"),
  arrowRightGrey: makeSrcSet("./arrow_right_grey"),
  verifiedUserSrc: makeSrcSVG("./verified_user"),
  verifiedUser: makeSrcSetSVG("./verified_user"),
  productServiceBg: makeSrcPNG("./product_service_bg"),
};

export default images;
